import catalog from "./catalog.json";
// Keep existing aggregate R2 identifiers and totals until their layout is verified.
// For new stories, optional chapters can derive totals without duplicate edits.
export const releases = catalog.releases;
// Undated videos retain catalogue order; dates refer to the video release.
export const videoReleases = releases
  .filter((release) => release.isReleased && release.video)
  .sort(
    (a, b) =>
      (Date.parse(b.video.releasedAt || b.releasedAt) || 0) -
      (Date.parse(a.video.releasedAt || a.releasedAt) || 0),
  )
  .slice(0, 3);
export const stories = catalog.stories.map((story) =>
  story.chapters
    ? {
        ...story,
        pages: story.chapters.reduce((sum, chapter) => sum + chapter.pages, 0),
      }
    : story,
);
